import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

//
import Button from "../../../components/button/Button";
import IMGLEFT from "../../../assets/images/about-eye-priority-left.jpg";
import IMGRIGHT from "../../../assets/images/about-eye-priority-right.jpg";

export default function AboutEyePriority() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledAboutEyePriority>
      <div className="container">
        <div className="about-eye-priority__wrap">
          <div className="about-eye-priority__left">
            <h1
              dangerouslySetInnerHTML={{ __html: t("aboutEyePriorityTitle") }}
            />
            <p>{t("aboutEyePriorityText")}</p>
            {/* <ul>
              <li>
                <IconWrapper w={45} h={45} iconW={18} iconH={18} icon="dna" />
                <p>{t("aboutEyePriorityDNA")}</p>
              </li>
              <li>
                <IconWrapper w={45} h={45} iconW={20} iconH={20} icon="eye" />
                <p>{t("aboutEyePriorityEYE")}</p>
              </li>
            </ul> */}
            <div>
              <img src={IMGLEFT} alt="IMGLEFT" />
            </div>
          </div>
          <div className="about-eye-priority__right">
            <div className="img-right__wrapper">
              <img src={IMGRIGHT} alt="IMGRIGHT" />
            </div>
            <p>{t("aboutEyePriorityText2")}</p>
            {/* <ul>
                <li>
                  <h2>20+</h2>
                  <p>{t("aboutEyePriority20PLUS")}</p>
                </li>
                <li>
                  <h2>300+</h2>
                  <p>{t("aboutEyePriority300PLUS")}</p>
                </li>
              </ul> */}
            <div>
              <Button onClick={() => handleNavigate("/contact")} hover="white">
                {t("aboutEyePriorityBtn")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </StyledAboutEyePriority>
  );
}

const StyledAboutEyePriority = styled.section`
  padding: 140px 0;
  background-color: var(--dark-blue);

  .about-eye-priority {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }

    &__left {
      h1 {
        color: var(--white);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: var(--space-title-subtitle);
      }

      & > p {
        color: var(--white);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        margin-bottom: 32px;
      }

      ul {
        display: flex;
        align-items: center;
        gap: 50px;
        margin-bottom: 36px;

        li {
          display: flex;
          align-items: center;
          gap: 16px;

          p {
            color: var(--white);
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 26px;
          }
        }
      }

      & > div {
        overflow: hidden;
        line-height: 0;

        img {
          width: 100%;
          object-fit: cover;
        }
      }
    }

    &__right {
      display: flex;
      flex-direction: column;
      padding-top: 16px;

      .img-right__wrapper {
        overflow: hidden;
        margin-bottom: 32px;
        line-height: 0;

        img {
          width: 100%;
          object-fit: cover;
        }
      }

      & > p {
        color: var(--white);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        margin-bottom: 32px;
      }

      ul {
        display: flex;
        align-items: center;
        gap: 50px;

        li {
          h2 {
            color: var(--white);
            font-size: 48px;
            font-style: normal;
            font-weight: 600;
            line-height: 58px; /* 114% */
            margin-bottom: 8px;
          }

          p {
            color: var(--white);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; /* 146.667% */
          }
        }
      }

      aside {
        border: 1px solid red;
        margin-top: auto;
      }
    }
  }
`;
